import { createAsyncThunk } from "@reduxjs/toolkit"
import apiRequest from "../../lib/http"

export const createNote = createAsyncThunk('notes/createNote', async ({
                                                                        userId,
                                                                        text,
                                                                        mentions
                                                                      }, { rejectWithValue }) => {
  try {
    const response = await apiRequest.post(`/notes/users/${userId}`, { text, mentions })
    return response.data
  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message
    return rejectWithValue(errorMessage)
  }
})

export const getAllNotes = createAsyncThunk('notes/getAllNotes', async ({
                                                                          userId,
                                                                          searchQuery,
                                                                          limit,
                                                                          offset
                                                                        }, { rejectWithValue }) => {
  try {
    const response = await apiRequest.get(`/notes/users/${userId}`, { params: { searchQuery, limit, offset } })
    return response.data
  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message
    return rejectWithValue(errorMessage)
  }
})

export const updateNoteById = createAsyncThunk('notes/updateNoteById', async ({
                                                                                noteId,
                                                                                text,
                                                                                mentions
                                                                              }, { rejectWithValue }) => {
  try {
    const response = await apiRequest.put(`/notes/${noteId}`, { text, mentions })
    return response.data
  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message
    return rejectWithValue(errorMessage)
  }
})

export const removeNoteById = createAsyncThunk('notes/removeNoteById', async (noteId, { rejectWithValue }) => {
  try {
    const response = await apiRequest.delete(`/notes/${noteId}`)
    return response.data
  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message
    return rejectWithValue(errorMessage)
  }
})

export const getMentionableUsers = createAsyncThunk(
  'notes/getMentionableUsers',
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiRequest.get('/workspace-users/mentions')
      return response.data
    } catch (error) {
      const errorMessage =
        error.response?.data?.error?.errors?.[0]?.message || 'Failed to load users'
      return rejectWithValue(errorMessage)
    }
  }
)
